import type { DeepReadonly } from "vue";
import type { ActionableMetadata, ContentMetadata_ACTIONABLE, ContentMetadata_SUMMARY, SummaryMetadata } from "@newgenerated/shared/schema";

export const convertToSummaryContentMetadata = (summary: DeepReadonly<SummaryMetadata>): ContentMetadata_SUMMARY => {
  return {
    backgroundColor: summary.backgroundColor,
    common: {
      audioActive: summary.audioActive,
      coverUri: summary.coverUri,
      description: summary.subtitle,
      inactive: !summary.active && summary.previewAvailable,
      language: summary.language,
      leadIn: summary.authorInfo,
      link: `/summary/${summary.dataId}`,
      title: summary.title ?? "",
      activatedAt: summary.activatedAt,
    },
    contentId: { contentType: "SUMMARY", id: BigInt(summary.dataId) },
    contentType: "SUMMARY",
    documentType: summary.documentType,
    miabId: summary.miabId,
    sourceType: summary.sourceType,
  };
};

export const convertToActionableContentMetadata = (actionable: DeepReadonly<ActionableMetadata>): ContentMetadata_ACTIONABLE => {
  return {
    contentType: "ACTIONABLE",
    common: {
      audioActive: false,
      coverUri: actionable.coverUri,
      description: actionable.description,
      inactive: !actionable.active,
      language: actionable.language,
      leadIn: "",
      link: `/actionables/${actionable.actionableId}`,
      title: actionable.title,
      activatedAt: actionable.activatedAt,
    },
    contentId: { contentType: "ACTIONABLE", id: actionable.actionableId },
  };
};
